import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: null,
  isLoading: false,
  error: null,
  success: null,
};

const changePasswordSlice = createSlice({
  name: "changePassword",
  initialState: initialState,
  reducers: {
    changePasswordStart(state) {
      state.isLoading = true;
      state.error = null;
      state.success = null;
    },
    changePasswordSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.success = true;
    },
    changePasswordFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    },
    clearChangePasswordState() {
      return initialState;
    },
  },
});

export const {
  changePasswordStart,
  changePasswordSuccess,
  changePasswordFailure,
  clearChangePasswordState,
} = changePasswordSlice.actions;
export default changePasswordSlice.reducer;
